import moment from 'moment';
import React from 'react';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

export const measuresColumns = (t, linkToEvent) => [
  {
    dataIndex: 'title',
    title: t('Title'),
    render: (title, all) => {
      return all.isEvent ? (
        <div>
          <div className={formatClassname(['vertical-line-expanded', all.isLast && 'is-last'])} />
          <div className="horizontal-line-expanded" />
          {linkToEvent(all.datastakeId)}
        </div>
      ) : title;
    },
    ellipsis: true,
  },
  {
    dataIndex: 'associatedActions',
    title: t('Associated Actions'),
    ellipsis: true,
    render: (value, all) => {
      if (Array.isArray(value)) {
        return `${value.length} ${t('actions')}`;
      }
      return all.eventTitle;
    },
  },
  {
    dataIndex: 'createdAt',
    title: t('Last Updated'),
    render: (value) => moment(value).format('DD MMM YYYY'),
  },
  {
    dataIndex: 'measure',
    title: t('Type of Measure'),
    render: (data) => {
      switch (data) {
        case 'riskMitigationMeasures':
          return t('Risk Mitigation Measures');
        case 'other':
          return t('Other')
        case 'incidents':
          return t('Incidents');
        default:
          return data;
      }
    }
  },
];

export const mapMeasures = ({ measures, measuresValue, status, events }) => {
  const IS_COMPLETED = status === 'completed';

  const check = (measure) => {
    if (IS_COMPLETED) {
      return typeof measure.completedAt === 'string';
    }
    return typeof measure.completedAt !== 'string';
  };

  return measures.reduce((all, item) => {
    const measure = measuresValue.find((m) => m.id === item.id);
    if (measure) {
      if (check(measure)) {
        const children = measure.events.map((e, i) => {
          const event = events.find((ev) => ev.id === e) || {};
          return {
            ...event,
            title: event.datastakeId,
            associatedActions: event.description,
            isEvent: true,
            measure: event.typeOfEvent,
            measureId: measure.id,
            isLast: i === measure.events.length - 1,
          };
        });
        all.push({
          ...item,
          associatedActions: measure.events,
          children,
          key: measure.id,
        });
      }
    } else if (!IS_COMPLETED) {
      all.push({
        ...item,
        associatedActions: [],
        key: item.id,
      });
    }
    return all;
  }, []);
}
